import React from 'react';
import { motion } from 'framer-motion';
import { MoonIcon, WavesIcon, LeafIcon } from 'lucide-react';
import { Reveal } from '../ui/Reveal';
import { HOTEL, HOTEL_CABANAS_IMG } from '../../data/retiro';
const DATOS = [{
  Icono: WavesIcon,
  titulo: 'Cabañas sobre la laguna',
  texto: 'Palafitos de madera y palma con el agua turquesa bajo tus pies.'
}, {
  Icono: MoonIcon,
  titulo: '4 noches en Akalki + 1 en Cancún',
  texto: 'Cuatro noches frente a la Laguna de los Siete Colores y una última noche en Cancún para el cierre.'
}, {
  Icono: LeafIcon,
  titulo: 'Naturaleza y silencio',
  texto: 'Manglar, cenotes de agua dulce, temazcal, spa y huerto sintrópico dentro de la misma propiedad.'
}];
export function Akalki() {
  return <section id="akalki" className="w-full" data-id="element-35" data-mp="55ldj58myx41">
      <div className="relative h-[70vh] min-h-[420px] w-full overflow-hidden" data-id="element-36" data-mp="57fyukntkr8n">
        <motion.img src={HOTEL_CABANAS_IMG} alt="Cabañas de palma sobre pilotes en la Laguna de los Siete Colores, Akalki, Bacalar" className="h-full w-full object-cover" initial={{
        scale: 1.08
      }} whileInView={{
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 1.6,
        ease: 'easeOut'
      }} data-id="element-37" data-mp="5qluzh1e3hx" />
        <div className="absolute inset-0" style={{
        background: 'linear-gradient(180deg, rgba(42,36,32,0.15) 0%, rgba(42,36,32,0.25) 45%, rgba(42,36,32,0.82) 100%)'
      }} data-id="element-38" data-mp="13sa9u3dgbobk" />
        <div className="absolute inset-x-0 bottom-0 mx-auto w-full max-w-7xl px-5 pb-12 sm:px-8 sm:pb-16" data-id="element-39" data-mp="utf7x3hfx0e2">
          <Reveal data-id="element-40" data-mp="yu8w7xysoh7h">
            <span className="inline-flex items-center gap-2 text-xs font-medium uppercase tracking-[0.3em]" style={{
            color: 'var(--jasmine)'
          }} data-id="element-41" data-mp="yrmithp837hc">
              <span className="h-px w-8" style={{
              background: 'var(--jasmine)'
            }} data-id="element-42" data-mp="2ri6tw8mj4mep" />
              Nuestra casa en Bacalar
            </span>
            <h2 className="mt-4 max-w-3xl font-heading text-3xl font-light leading-tight text-white sm:text-5xl" data-id="element-43" data-mp="2ip3h82jpkdl4">
              Akalki: dormir sobre la Laguna de los Siete Colores
            </h2>
            <p className="mt-4 max-w-2xl text-base leading-relaxed text-white/85" data-id="element-44" data-mp="3ahkmam4m1p33">
              Un refugio de palafitos, cenotes y manglar donde el agua marca el
              ritmo del día. Aquí el lujo no es el mármol: es el silencio, el
              amanecer sobre el agua y no tener a dónde correr.
            </p>
          </Reveal>
        </div>
      </div>

      <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8 sm:py-24" data-id="element-45" data-mp="2wjnpbom8vgnw">
        <div className="grid gap-6 md:grid-cols-2" data-id="element-46" data-mp="1q2sg8qs6wans">
          {HOTEL.map((h, i) => <Reveal key={h.titulo} delay={i * 0.1} data-id="element-47" data-mp="1l1cxx6heci93" data-mpi={i}>
              <figure className="group h-full overflow-hidden rounded-[2rem] bg-white shadow-sm" data-id="element-48" data-mp="1ay7hy1u8ror4">
                <div className="overflow-hidden" data-id="element-49" data-mp="1fxaib8za16sr">
                  <img src={h.imagen} alt={h.alt} className="aspect-[4/3] w-full object-cover transition-transform duration-700 group-hover:scale-[1.04]" data-id="element-50" data-mp="1fxskem8mef8l" />
                </div>
                <figcaption className="p-7" data-id="element-51" data-mp="1toxmduzgnjm3">
                  <h3 className="font-heading text-xl font-normal" style={{
                color: 'var(--ink)'
              }} data-id="element-52" data-mp="1to5rkmdotpwv">
                    {h.titulo}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed" style={{
                color: 'rgba(42,36,32,0.72)'
              }} data-id="element-53" data-mp="28mhp0v8vx2p3">
                    {h.texto}
                  </p>
                </figcaption>
              </figure>
            </Reveal>)}
        </div>

        <div className="mt-10 grid gap-6 sm:grid-cols-3" data-id="element-54" data-mp="24n7mjbdhcnj3">
          {DATOS.map(({
          Icono,
          titulo,
          texto
        }, i) => <Reveal key={titulo} delay={i * 0.08} data-id="element-55" data-mp="1zsad43cagc5o" data-mpi={i}>
              <div className="flex h-full flex-col gap-3 rounded-3xl border p-7" style={{
            borderColor: 'rgba(24,161,184,0.25)',
            backgroundColor: 'rgba(24,161,184,0.05)'
          }} data-id="element-56" data-mp="2donwxj4aopnb">
                <Icono className="h-6 w-6" style={{
              color: 'var(--blugreen)'
            }} aria-hidden data-id="element-57" data-mp="1gzzsjpli50wd" />
                <h3 className="font-heading text-lg font-normal" style={{
              color: 'var(--ink)'
            }} data-id="element-58" data-mp="1pzmhhbx1oe8j">
                  {titulo}
                </h3>
                <p className="text-sm leading-relaxed" style={{
              color: 'rgba(42,36,32,0.72)'
            }} data-id="element-59" data-mp="xaxoy1a21h8e">
                  {texto}
                </p>
              </div>
            </Reveal>)}
        </div>
      </div>
    </section>;
}